import { createContext, ReactNode, useContext, useState } from 'react';

import { ModalTypes } from '@dbt-labs/sourdough';

type ModalData = {
  isVisible: boolean;
  title: string;
  content: ReactNode;
  modalType: ModalTypes;
  openModal: (title: string, modalType: ModalTypes, content: ReactNode) => void;
  closeModal: () => void;
};

const ModalContext = createContext<ModalData>({
  isVisible: false,
  title: '',
  content: null,
  modalType: 'alert',

  openModal: () => undefined,
  closeModal: () => undefined,
});

export const useModalProvider = () => useContext(ModalContext);

export interface ModalContextProps {
  children: ReactNode;
}

function ModalProvider({ children }: ModalContextProps) {
  const [isVisible, setVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState<ReactNode>(null);
  const [modalType, setModalType] = useState<ModalTypes>('alert');

  const openModal = (title: string, modalType: ModalTypes, content: ReactNode) => {
    setTitle(title);
    setContent(content);
    setModalType(modalType);
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
  };

  return (
    <ModalContext.Provider
      value={{
        isVisible: isVisible,
        title: title,
        content: content,
        openModal: openModal,
        closeModal: closeModal,
        modalType: modalType,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}

export default ModalProvider;
